import { render, staticRenderFns } from "./cpt-dataV-border.vue?vue&type=template&id=6f07707e&scoped=true"
import script from "./cpt-dataV-border.vue?vue&type=script&lang=js"
export * from "./cpt-dataV-border.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f07707e",
  null
  
)

export default component.exports